
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { type RetentionPolicy } from '@/components/admin/certificates/types';

export function usePolicyFetching() {
  const { 
    data: policies, 
    isLoading, 
    error, 
    refetch 
  } = useQuery({
    queryKey: ['retentionPolicies'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('retention_policies')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data as RetentionPolicy[];
    },
  });

  return {
    policies,
    isLoading,
    error,
    refetch
  };
}
